var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgVideoMenu = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 13.333,
    viewBox: "0 0 20 13.333",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "video",
    d: "M2.222,65.111a1.11,1.11,0,0,0-1.111,1.111v8.889a1.11,1.11,0,0,0,1.111,1.111h8.889a1.11,1.11,0,0,0,1.111-1.111V66.222a1.11,1.11,0,0,0-1.111-1.111ZM0,66.222A2.224,2.224,0,0,1,2.222,64h8.889a2.224,2.224,0,0,1,2.222,2.222v8.889a2.224,2.224,0,0,1-2.222,2.222H2.222A2.224,2.224,0,0,1,0,75.111Zm18.035,9.837-3.59-1.976V72.816l4.125,2.271a.212.212,0,0,0,.1.028.216.216,0,0,0,.215-.215V66.438a.216.216,0,0,0-.215-.215.223.223,0,0,0-.1.028l-4.125,2.267V67.25l3.59-1.976A1.328,1.328,0,0,1,20,66.438V74.9a1.328,1.328,0,0,1-1.965,1.163Z",
    transform: "translate(0 -64)"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgVideoMenu);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/video-menu.9c95323b590ac35b83a1caefc0200ef4.svg";